import { TextureVariant } from '@/modules/visualization/types';
import { Color } from '@thive/canvas';

export const SAFETY_BORDER_COLOR = Color.fromRGBA(255, 192, 16, 255);
export const SAFETY_BORDER_WIDTH = 100;
export const WALL_MATERIAL_TYPE_TO_TEXTURE_VARIANT = {
  BRICK: TextureVariant.Brick,
  CONCRETE: TextureVariant.Concrete,
  STONE: TextureVariant.Stone,
};
export const RACKING_BEAM_COLOR = Color.fromRGB(255, 120, 0);
export const RACKING_POST_COLOR = Color.fromRGB(190, 190, 190);
